import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, PRIMARY_OUTLET, NavigationEnd } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-global-breadcrumbs',
  templateUrl: './global-breadcrumbs.component.html',
  styleUrls: ['./global-breadcrumbs.component.scss']
})
export class GlobalBreadcrumbsComponent implements OnInit {
  breadcrumbs = [];
  pageTitle;

  constructor(public route: ActivatedRoute, private router: Router, public title: Title) {
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .pipe(map(() => this.route))
    .pipe(map((route) => {
      while (route.firstChild) {
        this.breadcrumbs = [];
        const root = route.firstChild.snapshot.parent.routeConfig;
        // console.log('???', route);
        const url = root.path;
        const routeData = route.snapshot.data;
        const label = routeData;
        this.breadcrumbs.push({ url, label });
        route = route.firstChild;
      }
      return route;
    }))
    .pipe(filter(route => route.outlet === PRIMARY_OUTLET))
    .subscribe(route => {

      const snapshot = this.router.routerState.snapshot;
      const url = snapshot.url;
      const routeData = route.snapshot.data;

      const label = routeData;
      this.pageTitle = label;
      this.title.setTitle(label ? `${this.pageTitle.title} - Book Domestic & International Flight Tickets at Low Airfares` : 'Belairtrip.com');
      // const params = snapshot.root.params;

      this.breadcrumbs.push({ url, label });
      // console.log(url, label);
    });
  }

  ngOnInit(): void {
  }

}

export interface BreadCrumb {
  label: string;
  url: string;
}
